import { render, staticRenderFns } from "./Highlightable.vue?vue&type=template&id=3523dcc0&scoped=true&"
import script from "./Highlightable.vue?vue&type=script&lang=ts&"
export * from "./Highlightable.vue?vue&type=script&lang=ts&"
import style0 from "./Highlightable.vue?vue&type=style&index=0&id=3523dcc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523dcc0",
  null
  
)

export default component.exports